import { Injectable } from '@angular/core';
import { TextbookAction } from '@textbook-api-client';
import { InternalApiService } from '../../internal/internal-api.service';

@Injectable()
export class TextbookActionsService {
  constructor(private internalApiService: InternalApiService) {}

  superEditorMode(id: TextbookAction): void {
    this.internalApiService.doSomeEditorStuff(id);
  }

  demoMode(isActive: boolean): void {
    // this.blockEverythingAndShowModal
  }
}
